import {Component} from '@angular/core';
// noinspection ES6PreferShortImport
import {WidgetInputDirective} from '../../directives';

@Component({
  selector: 'pt-widget-dpia',
  template: `
    <div
      class='widget-border'
      data-testid="widget-dpia"
      id='widget_{{initializationWidget.internalId}}'
      [ngSwitch]='initializationWidget?.version'>

      <pt-widget-dpia-v0
        *ngSwitchCase='0'
        [lockAcquired]='lockAcquired'
        [initializationWidget]='initializationWidget'
        [status]='status'>
      </pt-widget-dpia-v0>

      <pt-widget-version-missing
        *ngSwitchDefault
        [type]='initializationWidget?.type'
        [label]='initializationWidget?.label'
        [version]='initializationWidget?.version'>
      </pt-widget-version-missing>

    </div>
  `
})
export class WidgetDpiaComponent extends WidgetInputDirective {
}
